const permit = resolve => require(['@/pages/permit'], resolve);
export default [
  /*******************物流信息*******************/
  //平台许可快递
  {
    path: "/permit",
    name: "平台许可快递",
    component: permit
  }
]
